import axios, { AxiosResponse } from 'axios';
import { put, takeLatest, select , all, takeEvery} from 'redux-saga/effects';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { serverError } from '@state/auth/actions';
import host from '@utils/host';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';
import { UserManager } from 'oidc-client';

function* getUserConfig(action: actionsInterfaces.IGetUserConfigAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}userConfig`    
    if(action.email)callUrl=`${host}userConfig${action.email}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.userConfig.setUserConfig(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* addUserConfig(action: actionsInterfaces.IPostUserConfigAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}userConfig`, action.userConfig,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.userConfig.setUserConfig(response.data));
      if (action.callback) { action.callback(response.data[0]); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      yield put(actions.userConfig.addSuccess({status:response.status, id:action.userConfig.id, name:action.userConfig.user.name}));
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateUserConfig(action: actionsInterfaces.IUpdateUserConfigAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.put(`${host}userConfig/${action.userConfig.id}`,action.userConfig,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.userConfig.setUserConfig(response.data));
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

export default function* budgetSagas() {
  yield all([
    takeLatest(actionsTypes.GET_USERCONFIG_INFO, getUserConfig),
    takeEvery(actionsTypes.ADD_USERCONFIG, addUserConfig),
    takeLatest(actionsTypes.UPDATE_USERCONFIG, updateUserConfig)
  ])
}

